export default "types/assets/src/fonts/Pretendard-Thin.otf"